import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import StarEdgyFilledIcon from '../../../../assets/icons/StarEdgyFilledIcon';
import { colorsPalette } from '../../../../theme';

const RatingShort = ({ value = 0 }: { value?: number }) => {
  return (
    <Wrapper>
      <Amount>{value}</Amount>
      <FilledStarIcon />
    </Wrapper>
  );
};

export default RatingShort;

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 0,
});
const Amount = styled(Typography)({
  marginRight: 6,
  fontSize: 18,
  color: colorsPalette.blue,
});
const FilledStarIcon = styled(StarEdgyFilledIcon)({
  width: 20,
  height: 20,
  marginRight: 6,
  color: colorsPalette.blue,
});
